import {
  FETCH_ACCOUNT_DATA_LIST_FAILED,
  FETCH_ACCOUNT_DATA_LIST_SUCCESS,
  FETCH_ACCOUNT_DATA_LIST_LOADING,
} from "../actions/manageAccount";

const defVal = {
  dataListLoading: false,
  dataList: [],
  dataListTotal: 0,
};

export default (state = defVal, action) => {
  switch (action.type) {
    case FETCH_ACCOUNT_DATA_LIST_LOADING:
      return Object.assign({}, state, {
        dataListLoading: true,
      });
    case FETCH_ACCOUNT_DATA_LIST_SUCCESS:
      return Object.assign({}, state, {
        dataListLoading: false,
        dataList: action.dataList,
        dataListTotal: action.dataListTotal,
      });
    case FETCH_ACCOUNT_DATA_LIST_FAILED:
      return Object.assign({}, state, {
        dataListLoading: false,
      });

    default:
      return state;
  }
};
